"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[72453],{

/***/ 64410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserPhoto = function(email) {
    /* photo url 저장 */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("/images/market/no-img.png"), url = ref[0], setUrl = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().photo !== "") setUrl(docValue.data().photo);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return url;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserPhoto);


/***/ }),

/***/ 81268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5566);
/* harmony import */ var components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4534);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32692);





var MaterialModal = function(param) {
    var children = param.children, open = param.open, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        "aria-labelledby": "spring-modal-title",
        "aria-describedby": "spring-modal-description",
        className: "popup-wrap",
        open: open,
        onClose: closeModal,
        closeAfterTransition: true,
        disableScrollLock: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        outline: 0,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: open,
            className: "center2",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaterialModal);


/***/ }),

/***/ 9085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_FormatDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87936);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33426);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34950);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79794);












var MessageSendModal = function(param) {
    var messageModalVisible = param.messageModalVisible, closeModal = param.closeModal, receiveEmail = param.receiveEmail, receiveUserName = param.receiveUserName;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), message = ref[0], setMessage = ref[1];
    var handleModalOkButton = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var date, createdAt, text, sendEmail, sendUserName, collectionRefReceive, values, _tmp, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        date = new Date();
                        createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_8__/* .FormatDate */ .r2)(date);
                        if (message === "") {
                            text = "전송할 메시지 내용을 작성해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text);
                            return [
                                2
                            ];
                        }
                        sendEmail = settings.email;
                        sendUserName = settings.name;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc(receiveEmail).collection("message")
                        ];
                    case 2:
                        collectionRefReceive = _state.sent();
                        _tmp = {};
                        values = (_tmp.sendEmail = sendEmail, _tmp.sendUserName = sendUserName, _tmp.message = message, _tmp.receiveEmail = receiveEmail, _tmp.receiveUserName = receiveUserName, _tmp.createdAt = createdAt, _tmp);
                        return [
                            4,
                            collectionRefReceive.add(values).then(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(doc) {
                                    var docRefSend;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc(sendEmail).collection("message").doc(doc.id)
                                                ];
                                            case 1:
                                                docRefSend = _state.sent();
                                                return [
                                                    4,
                                                    docRefSend.set(values)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(doc) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 3:
                        _state.sent();
                        setMessage("");
                        closeModal();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("메시지가 전송되었습니다.");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        setMessage("");
                        closeModal();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("메시지 전송 실패");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModalOkButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        open: messageModalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content center modal-width-150",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: function() {
                                return closeModal();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    className: "text-primary font-gmarket-medium text-2xl font-bold mb-4 center",
                    children: "메시지 전송"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full flex justify-start px-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "pr-2",
                            children: "받는 사람"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "pr-2",
                            children: ":"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: receiveUserName ? receiveUserName.length > 15 ? "".concat(receiveUserName.slice(0, 15), "...") : receiveUserName : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            placeholder: "메시지 내용을 입력하세요",
                            fullWidth: true,
                            value: message,
                            onChange: function(e) {
                                return setMessage(e.target.value);
                            },
                            multiline: true,
                            rows: 8,
                            className: "w-full",
                            InputLabelProps: {
                                shrink: true
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "btn btn-modal-o w-2/3 py-3",
                        onClick: function() {
                            return handleModalOkButton();
                        },
                        children: "보내기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MessageSendModal);


/***/ }),

/***/ 4534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39920);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







/* Material-UI 모달 Fade */ var ModalFade = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Fade(props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "in",
        "children",
        "onEnter",
        "onExited"
    ]);
    var style = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
        config: {
            duration: 10
        },
        from: {
            opacity: 0
        },
        to: {
            opacity: open ? 1 : 0
        },
        onStart: function() {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function() {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        style: style
    }, other), {
        children: children
    }));
});
ModalFade.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
    in: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    onEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onExited: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalFade);


/***/ }),

/***/ 72453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ userNameHover_ToUser; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/AccountBox.js
var AccountBox = __webpack_require__(47622);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(52387);
// EXTERNAL MODULE: ./components/UserPhoto.js
var UserPhoto = __webpack_require__(64410);
// EXTERNAL MODULE: ./components/ProjectFirestore.js
var ProjectFirestore = __webpack_require__(79794);
// EXTERNAL MODULE: ./components/modal/MessageSendModal.js
var MessageSendModal = __webpack_require__(9085);
;// CONCATENATED MODULE: ./components/userNameFormat.js
// import { useState, useEffect } from "react";
var UserNameFormat = function(name) {
    var tempName = name;
    if (name.length > 15) tempName = "".concat(name.slice(0, 15), "...");
    return tempName;
};
/* harmony default export */ var userNameFormat = (UserNameFormat);

// EXTERNAL MODULE: ./components/UserUid.js
var UserUid = __webpack_require__(20137);
;// CONCATENATED MODULE: ./components/userNameHover/ToUser.js













var ToUser = function(param) {
    var email = param.email;
    var ref = (0,react.useState)(false), messageModalVisible = ref[0], setMessageModalVisible = ref[1];
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var ref2 = (0,react.useState)(), data = ref2[0], setData = ref2[1];
    /* 사용자 프로필 가져오기 */ var photoUrl = (0,UserPhoto/* default */.Z)(email);
    (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var docRef, docValue, _tmp, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    docRef = ProjectFirestore/* projectFirestore.collection */.H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 1:
                    docValue = _state.sent();
                    _tmp = {};
                    if (docValue.exists) {
                        setData((0,_object_spread/* default */.Z)(_tmp, docValue.data()));
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    BasicAlert(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleMessageSend = function() {
        setAnchorEl(null);
        setMessageModalVisible(true);
    };
    var open = Boolean(anchorEl);
    var id = open ? "simple-popover" : undefined;
    var userUid = (0,UserUid/* default */.Z)(email);
    if (!data) return "".concat(email);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mb-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "text-888 mr-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountBox/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-0 text-333 text-13 font-bold cursor-pointer leading-5",
                        onClick: handleClick,
                        children: userNameFormat(data.name)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "aiso-card aiso-shadow transition cursor-pointer max-w-sm p-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "img-cover-box w-16 h-16 rounded-full border",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: photoUrl,
                                            alt: ""
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "whitespace-pre-line break-all pl-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "truncate-1-lines text-333 font-bold mb-2",
                                        children: [
                                            " ",
                                            data.name
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex justify-between items-center mt-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn btn-grayPrimary btn-sm text-13 mr-2",
                                    onClick: handleMessageSend,
                                    children: "메시지 전송"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        pathname: "/user/profile/[id]",
                                        query: {
                                            id: "".concat(userUid)
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "btn btn-grayPrimary text-13 btn-sm",
                                        children: "프로필 보기"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageSendModal/* default */.Z, {
                messageModalVisible: messageModalVisible,
                closeModal: function() {
                    return setMessageModalVisible(false);
                },
                receiveEmail: data.email,
                receiveUserName: data.name
            })
        ]
    });
};
/* harmony default export */ var userNameHover_ToUser = (ToUser);


/***/ })

}]);